import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardTimePicker,
} from '@material-ui/pickers';
import { getFormat24 } from 'reducers/TimeReducer';
import { TextField } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  filters: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    '& > div': {
      marginRight: theme.spacing(2),
    },
    '& > button': {
      marginTop: 7,
    },
  },
  filterWrap: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

const defaultStartDate = new Date();
defaultStartDate.setDate(defaultStartDate.getDate() - 30);

function SearchTimePicker(props) {
  const classes = useStyles();
  const format24 = getFormat24();
  const { timeFrom, setTimeFrom, timeTo, setTimeTo, actions, loaded, btnDisabled = false } = props;

  // useEffect(() => {
  //   search();
  //   // eslint-disable-next-line
  // }, []);

  // const search = () => props.search(dateFrom, dateTo);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div className={classes.filterWrap}>
        <div className={classes.filters}>
          {/* <KeyboardDatePicker
            disableToolbar
            variant="inline"
            inputVariant="outlined"
            format="MM/dd/yyyy"
            margin="normal"
            label="Date From"
            value={dateFrom}
            onChange={(date) => setDateFrom(date)}
            maxDate={dateTo}
            autoOk
            size="small"
          /> */}
          <KeyboardTimePicker
            label="Start Time"
            inputVariant="outlined"
            size="small"
            margin={'normal'}
            ampm={!format24}
            value={timeFrom}
            onChange={setTimeFrom}
            renderInput={(params) => <TextField {...params} />}
          />
          <KeyboardTimePicker
            label="End Time"
            inputVariant="outlined"
            size="small"
            margin={'normal'}
            ampm={!format24}
            value={timeTo}
            onChange={setTimeTo}
            renderInput={(params) => <TextField {...params} />}
          />
          {/* <KeyboardDatePicker
            disableToolbar
            variant="inline"
            inputVariant="outlined"
            format="MM/dd/yyyy"
            margin="normal"
            label="Date To"
            value={dateTo}
            onChange={(date) => setDateTo(date)}
            minDate={dateFrom}
            autoOk
            size="small"
          /> */}
          {/* <Button variant="outlined" onClick={search} disabled={!loaded || btnDisabled}>
            Search
          </Button> */}
        </div>
        {/*  {actions} */}
      </div>
    </MuiPickersUtilsProvider>
  );
}

export default SearchTimePicker;
